import React, { Component } from 'react';
import ReactDom from 'react-dom';
import RegisterForm from './register-form.jsx'
import UserAgreement from './user-agreement.jsx'

import './style.less'
export default class Register extends Component {
    constructor() {
        super()
        this.state = {
            isShowUserAgreement: false
        }
    }
    
    showUserAgreement = () => {
        this.setState({
            isShowUserAgreement: !this.state.isShowUserAgreement
        })
    }
    
    render() {
        return (
            <div id="registerWrap">
                {this.state.isShowUserAgreement
                    ?
                    <UserAgreement onClick={this.showUserAgreement}/>
                    :
                    <RegisterForm onClick={this.showUserAgreement}/>
                }
            
            </div>
        )
        
    }
}

ReactDom.render(
    <Register/>,
    document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/register/entry.jsx